// state.ts — module-shared mutable state for the websocket bundle.
//
// `ws` and `sl_context` were single `let` bindings at the top of the pre-split
// handlers.ts module. After the file split, multiple sibling modules need to
// read (and `setup.ts` needs to reassign) these values. ES module named-import
// live bindings give us this for read access — `import { ws } from './state'`
// in any consumer file always reflects the latest value `state.ts` holds.
// Reassignment must go through the setter helpers; bare `ws = next` from
// outside this module isn't allowed by the ES module spec.

export let ws: WebSocket | undefined;
export let sl_context: FtSidelogContext | null | undefined;

export function setWs(next: WebSocket | undefined) { ws = next; }
export function setSlContext(next: FtSidelogContext | null | undefined) { sl_context = next; }
